import { StructureBlockContent as StructureBlockContentBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import StructureBlockContentNodeView from '@/components/editor/StructureBlockContentNodeView'

export const StructureBlockContent = StructureBlockContentBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(StructureBlockContentNodeView)
    },
})
